var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import clsx from 'clsx';
import defaultTheme from '@ntuctech/devex-tangram/Theme/defaultTheme';
import Typography from '../Typography';
import Box from '../Box';
import SvgStarFilled from '../Icon/SvgStarFilled';
import { withForwardedRef } from '../utils/helpers/reactHelpers';
const IconFilter = styled.div `
  svg {
    max-width: 1rem !important;
    max-height: 1rem !important;
    min-width: 1rem !important;
    min-height: 1rem !important;
    margin: 0.25rem 0.25rem 0 0;
    fill: ${(props) => props.color};
  }
`;
const RatingValues = styled(Box) `
  display: flex;
  & > svg {
    margin-right: 0.25rem;
  }
  & > svg:last-child {
    margin-right: 0;
  }
`;
const ChipSC = styled.div `
  user-select: none;
  outline: 0;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: 0 ${(p) => p.theme.SizeMarginChipBase}
    ${(p) => p.theme.SizeMarginChipBase} 0;

  height: ${(p) => p.theme.SizeHeightChip};
  border-radius: ${(p) => p.theme.SizeBorderRadiusChip};
  padding: ${(p) => p.theme.SizePaddingChipY}
    ${(p) => p.theme.SizePaddingChipX};

  color: ${(p) => p.theme.ColorFontChipBase};
  background-color: ${(p) => p.theme.ColorBackgroundChipDefault};
  border: ${(p) => p.theme.SizeBorderWidthChip} solid
    ${(p) => p.theme.ColorBorderChipDefault};

  will-change: background-color, border, border-color, box-shadow, left;
  transition: background-color 0.3s, border 0.3s, border-color 0.3s, box-shadow 0.3s,
    left 0.3s;

  :hover {
    cursor: pointer;
    background-color: ${(props) => props.theme.ColorBackgroundChipHover};
  }

  :active {
    background-color: ${(props) => props.theme.ColorBackgroundChipActive};
    border-color: ${(p) => p.theme.ColorBorderChipActive};
    box-shadow: 0rem 0rem 0rem 1px
      ${(p) => p.theme.ColorBorderChipActive};
  }

  ._ndsChip__count-filter {
    margin-left: 0.25rem;
  }

  ._ndsChip__count {
    margin-left: 0.25rem;
    color: ${(p) => p.theme.ColorBaseMineShaft500};
  }

  &._ndsChip--selected {
    background-color: ${(props) => props.theme.ColorBackgroundChipActive};
    border: ${(p) => p.theme.SizeBorderWidthChip} solid
      ${(p) => p.theme.ColorBorderChipActive};
  }

  &._ndsChip--selected:hover,
  &._ndsChip--selected:active {
    cursor: default;
    background-color: ${(props) => props.theme.ColorBackgroundChipActive};
    border: ${(p) => p.theme.SizeBorderWidthChip} solid
      ${(p) => p.theme.ColorBorderChipActive};
    box-shadow: none;
    ${(props) => props.isFilter &&
    'border: 1px solid #0b2e65 !important; & h6 { color: #104393 !important } & svg { fill: #104393 !important }'}
  }

  &._ndsChip--disabled ._ndsChip__count,
  &._ndsChip--disabled ._ndsChip__label {
    color: ${(props) => props.theme.ColorFontChipDisabled};
  }

  &._ndsChip--rating._ndsChip--selected:hover {
    cursor: pointer;
    border: ${(p) => p.theme.SizeBorderWidthChip} solid
      ${(p) => p.theme.ColorFontLinkActive};
    ._ndsChip__count {
      color: ${(p) => p.theme.ColorBaseBrandPrimary600};
    }
  }
  &._ndsChip--rating._ndsChip--selected:active {
    background-color: ${(props) => props.theme.ColorBackgroundChipActive};
    border-color: ${(p) => p.theme.ColorBorderChipActive};
    box-shadow: 0rem 0rem 0rem 1px
      ${(p) => p.theme.ColorBorderChipActive};
    ._ndsChip__count {
      color: ${(p) => p.theme.ColorBaseBrandPrimary500};
    }
  }

  &._ndsChip--disabled {
    /* pointer-events: none; */
    border-color: ${(props) => props.theme.ColorBorderChipDisabled};
  }
  &._ndsChip--disabled:hover,
  &._ndsChip--disabled:active {
    cursor: not-allowed;
    background-color: ${(p) => p.theme.ColorBackgroundChipDefault};
    border: ${(p) => p.theme.SizeBorderWidthChip} solid
      ${(props) => props.theme.ColorBorderChipDisabled};
    box-shadow: none;
  }

  &._ndsChip--disabled._ndsChip--selected {
    background-color: ${(props) => props.theme.ColorBackgroundChipSelectedDisabled};
    border-color: transparent;
  }

  &._ndsChip--filter._ndsChip--selected {
    cursor: pointer !important;
    svg {
      fill: #1454b8;
    }
    ._ndsChip__count-filter {
      margin-left: 0.25rem;
      color: #1454b8;
    }
    & ._ndsChip__label {
      color: #1454b8;
    }
  }

  &._ndsChip--filter._ndsChip--disabled._ndsChip--selected {
    svg {
      fill: ${(props) => props.theme.ColorFontChipDisabled} !important;
    }
    & ._ndsChip__label {
      color: ${(props) => props.theme.ColorFontChipDisabled} !important;
    }
    & ._ndsChip__count-filter {
      color: ${(props) => props.theme.ColorFontChipDisabled} !important;
    }
  }

  &._ndsChip--filter._ndsChip--selected:active {
    background-color: ${(props) => props.theme.ColorBackgroundChipActive};
    border-color: ${(p) => p.theme.ColorBorderChipActive};
    box-shadow: 0rem 0rem 0rem 1px
      ${(p) => p.theme.ColorBorderChipActive};
  }
`;
const Chip = (props) => {
    const { label, variant, ratingValue, resultCount, selected: selectedProp, disabled, forwardedRef, icon, filterValue, isFilter, className: classNameProp, rightIcon } = props, others = __rest(props, ["label", "variant", "ratingValue", "resultCount", "selected", "disabled", "forwardedRef", "icon", "filterValue", "isFilter", "className", "rightIcon"]);
    const classes = clsx({
        '_ndsChip--suggestion': variant === 'suggestion',
        '_ndsChip--rating': variant === 'rating',
        '_ndsChip--selected': selectedProp,
        '_ndsChip--disabled': disabled,
        '_ndsChip--filter': variant === 'filter'
    }, classNameProp);
    const color = disabled
        ? defaultTheme.ColorFontChipDisabled
        : defaultTheme.ColorIconRatingChipBase;
    const filterColor = disabled ? defaultTheme.ColorFontChipDisabled : '#333333';
    return (React.createElement(ChipSC, Object.assign({ isFilter: isFilter, ref: forwardedRef, className: classes }, others),
        icon && React.createElement(IconFilter, { color: filterColor }, icon),
        label && (React.createElement(Typography, { variant: "subhead1", className: "_ndsChip__label" }, label)),
        variant === 'rating' && (React.createElement(Fragment, null,
            React.createElement(RatingValues, null, Array.from(Array(ratingValue), (_, i) => (React.createElement(SvgStarFilled, { key: `star${i}`, size: "s", color: color })))),
            typeof resultCount === 'number' && (React.createElement(Typography, { variant: "body3", className: "_ndsChip__count" },
                "(",
                resultCount,
                ")")))),
        variant === 'filter' && (React.createElement(Fragment, null, typeof filterValue === 'number' && (React.createElement(Typography, { variant: "body3", className: "_ndsChip__count _ndsChip__count-filter" },
            "(",
            filterValue,
            ")")))),
        rightIcon && React.createElement(IconFilter, { color: filterColor }, rightIcon)));
};
Chip.propTypes = {
    label: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
        PropTypes.string
    ]),
    ratingValue: PropTypes.number,
    resultCount: PropTypes.number,
    variant: PropTypes.oneOf(['suggestion', 'rating', 'filter']),
    selected: PropTypes.bool,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    forwardedRef: PropTypes.any,
    icon: PropTypes.elementType,
    rightIcon: PropTypes.elementType,
    filterValue: PropTypes.number,
    isFilter: PropTypes.bool
};
Chip.defaultProps = {
    label: undefined,
    ratingValue: 5,
    resultCount: undefined,
    variant: 'suggestion',
    selected: false,
    disabled: false,
    className: undefined,
    forwardedRef: null,
    icon: null,
    rightIcon: null,
    filterValue: undefined,
    isFilter: false
};
export { Chip as ChipRootComp };
export default withForwardedRef(Chip);
//# sourceMappingURL=Chip.js.map